ko.bindingHandlers.datepicker = {
	init: function (element, valueAccessor, allBindingsAccessor) {
		//initialize datepicker with some optional options
		var $el = $(element);

		InitializeDatePicker($el);

		//handle the field changing by registering datepicker's changeDate event
		ko.utils.registerEventHandler(element, "dp.change", function (e) {
			var observable = valueAccessor();
			var currentDate = $el.data("DateTimePicker").date();
			observable(currentDate ? currentDate.format("MM/DD/YYYY HH:mm:ss") : null);

			// If this datepicker is linked to another, enforce min/max constraints
			var allBindings = allBindingsAccessor();

			if (allBindings.linkedMaxDate) {
				// This is a "From" date – set the minDate on the linked "To" datepicker
				var linkedMaxEl = $(allBindings.linkedMaxDate);
				if (linkedMaxEl.length && linkedMaxEl.data("DateTimePicker")) {
					linkedMaxEl.data("DateTimePicker").minDate(e.date || false);
				}
			}

			if (allBindings.linkedMinDate) {
				// This is a "To" date – set the maxDate on the linked "From" datepicker
				var linkedMinEl = $(allBindings.linkedMinDate);
				if (linkedMinEl.length && linkedMinEl.data("DateTimePicker")) {
					linkedMinEl.data("DateTimePicker").maxDate(e.date || false);
				}
			}
		});

		setTimeout(function () {
			var allBindings = allBindingsAccessor();
			var currentDate = $el.data("DateTimePicker").date();

			if (currentDate) {
				if (allBindings.linkedMaxDate) {
					var linkedMaxEl = $(allBindings.linkedMaxDate);
					if (linkedMaxEl.length && linkedMaxEl.data("DateTimePicker")) {
						linkedMaxEl.data("DateTimePicker").minDate(currentDate);
					}
				}

				if (allBindings.linkedMinDate) {
					var linkedMinEl = $(allBindings.linkedMinDate);
					if (linkedMinEl.length && linkedMinEl.data("DateTimePicker")) {
						linkedMinEl.data("DateTimePicker").maxDate(currentDate);
					}
				}
			}
		}, 0);

		//handle disposal (if KO removes by the template binding)
		ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
			$el.data("DateTimePicker").destroy();
		});
	},
	update: function (element, valueAccessor) {
		var bindingValue = valueAccessor();
		var value = ko.utils.unwrapObservable(bindingValue),
			$el = $(element);

		function normalizeDateValue(rawValue) {
			var normalized = rawValue;

			// handle date data coming via json from Microsoft
			if (String(normalized).indexOf('/Date(') === 0) {
				normalized = new Date(parseInt(String(normalized).replace(/\/Date\((.*?)\)\//gi, "$1")));
			}

			// Knockout/listing filters can briefly pass arrays or empty values during tab hydration.
			if (Array.isArray(normalized)) {
				normalized = normalized.length ? normalized[0] : null;
			}

			if (normalized === "" || typeof normalized === "undefined" || normalized === false) {
				normalized = null;
			}

			if (normalized === null) {
				return null;
			}

			if (moment.isMoment(normalized)) {
				return normalized.format("MM/DD/YYYY HH:mm:ss");
			}

			if (normalized instanceof Date) {
				return moment(normalized).format("MM/DD/YYYY HH:mm:ss");
			}

			if (typeof normalized === "string") {
				var parsedMoment = moment(normalized, [
					"MM/DD/YYYY HH:mm:ss",
					"MM/DD/YYYY",
					"YYYY-MM-DD",
					moment.ISO_8601
				], true);

				if (parsedMoment.isValid()) {
					return parsedMoment.format("MM/DD/YYYY HH:mm:ss");
				}

				// allow datetimepicker to handle truly custom strings, but avoid objects/arrays
				return normalized;
			}

			return null;
		}

		value = normalizeDateValue(value);
		if (value === null && ko.isObservable(bindingValue)) {
			bindingValue(null);
		}

		var current = $el.data("DateTimePicker").date();

		var currentFormatted = current ? current.format("MM/DD/YYYY HH:mm:ss") : null;
		if (currentFormatted !== value) {
			try {
				$el.data("DateTimePicker").date(value);
			} catch (e) {
				$el.data("DateTimePicker").date(null);
				if (ko.isObservable(bindingValue)) {
					bindingValue(null);
				}
			}
		}
	}
};